'use strict';

(function() {
	angular.module('ShargoApp')
		.controller('HeaderController', function($scope, $rootScope, $timeout, $window, $q){
			/*  --VARIABLES--  */
			var preheaderMargin = 0;
			var previousPageYOffset = -1;


			/*  --FUNCTIONS--  */
			function waitUntilElementLoaded(element) {
				var deferred = $q.defer();
				var checkExist = setInterval(function() {
					if (angular.element(element).length && angular.element(element)[0] && angular.element(element)[0].offsetHeight > 0) {
						clearInterval(checkExist);
						deferred.resolve();
					}
				}, 100);
				return deferred.promise;
			}

			function solid() {
				angular.element("header-shargo .header-container-solid").css("opacity", 1);
				if ($rootScope.pageConfiguration.header.callToAction.link) {
					if ($rootScope.pageConfiguration.header.callToAction.hide && (!$rootScope.isUserLogged || !$rootScope.pageConfiguration.header.logIn)) {
						angular.element("header-shargo .options .call-to-action").css({
							"pointer-events": "",
							"margin-right": "0px"
						});
						angular.element("header-shargo .options .call-to-action").addClass("animated");
					}
					else {
						angular.element("header-shargo .options .call-to-action").css({
							"opacity": 1,
							"pointer-events": "",
							"margin-right": "0px"
						});
					}
				}
			}

			function transparent() {
				angular.element("header-shargo .header-container-solid").css("opacity", 0);
				if ($rootScope.pageConfiguration.header.callToAction.link) {
					if ($rootScope.pageConfiguration.header.callToAction.hide && (!$rootScope.isUserLogged || !$rootScope.pageConfiguration.header.logIn)) {
						angular.element("header-shargo .options .call-to-action").css({
							"opacity": 0,
							"pointer-events": "none",
							"margin-right": -angular.element("header-shargo .options .call-to-action").innerWidth() + "px"
						});
						angular.element("header-shargo .options .call-to-action").removeClass("animated");
					}
					else {
						angular.element("header-shargo .options .call-to-action").css({
							"opacity": 1,
							"pointer-events": "",
							"margin-right": "0px"
						});
					}
				}
			}

			function updatePreheaderMargin(margin) {
				preheaderMargin -= margin;
				if (preheaderMargin < -40) { preheaderMargin = -40; }
				if (preheaderMargin > 0) { preheaderMargin = 0; }
				if ($rootScope.pageConfiguration.header.preheader) {
					angular.element("header-shargo .preheader").css({
						"margin-bottom": preheaderMargin + "px"
					});
				}
			}

			function updateMainMargin() {
				if ($rootScope.pageConfiguration.header.solid <= 0) {
					angular.element("main").css("padding-top", "70px");
				}
				else {
					angular.element("main").css("padding-top", "0px");
				}
			}

			function updateRatingHeader() {
				waitUntilElementLoaded("header-shargo .options .profile").then(function () {
					if ($rootScope.lang === "en") {
						angular.element("header-shargo .options .rating-header").css("left", angular.element("header-shargo .options").position().left - 30 + "px");
					}
					else if ($rootScope.lang === "es") {
						angular.element("header-shargo .options .rating-header").css("left", angular.element("header-shargo .options").position().left - 55 + "px");
					}
					else /* $rootScope.lang === "ca" */ {
						angular.element("header-shargo .options .rating-header").css("left", angular.element("header-shargo .options").position().left - 35 + "px");
					}
				});
				$timeout(function () {
					waitUntilElementLoaded("header-shargo .options .profile").then(function () {
						if ($rootScope.lang === "en") {
							angular.element("header-shargo .options .rating-header").css("left", angular.element("header-shargo .options").position().left - 30 + "px");
						}
						else if ($rootScope.lang === "es") {
							angular.element("header-shargo .options .rating-header").css("left", angular.element("header-shargo .options").position().left - 55 + "px");
						}
						else /* $rootScope.lang === "ca" */ {
							angular.element("header-shargo .options .rating-header").css("left", angular.element("header-shargo .options").position().left - 35 + "px");
						}
					});
				}, 500);
			}

			function ratingAction() {
				angular.element("header-shargo .options .rating-header").removeClass("animated");
				$rootScope.pendingRating = false;
				angular.element($window).unbind('resize', updateRatingHeader);
			}

			function updateHeaderScroll() {
				if (this.pageYOffset >= $rootScope.pageConfiguration.header.solid) {
					solid();
					if ($rootScope.pageConfiguration.header.preheader) {
						if (this.pageYOffset <= $rootScope.pageConfiguration.header.solid + 40) {
							if (this.pageYOffset > previousPageYOffset) {
								updatePreheaderMargin(this.pageYOffset - previousPageYOffset);
							}
							else {
								updatePreheaderMargin(this.pageYOffset - previousPageYOffset);
							}
						}
						else {
							angular.element("header-shargo .preheader").css("margin-bottom", "-40px");
						}
					}
				}
				else {
					transparent();
					if ($rootScope.pageConfiguration.header.preheader) {
						angular.element("header-shargo .preheader").css("margin-bottom", "0px");
					}
				}
				previousPageYOffset = this.pageYOffset;
			}

			/*  --EXECUTION--  */
			$scope.ratingAction = ratingAction;

			angular.element(document).ready(function () {
				$timeout(function () {
					updateMainMargin();
					updateRatingHeader();
					angular.element("header-shargo .header-container-solid").css("background-image", $rootScope.pageConfiguration.header.background);
					if ($window.pageYOffset >= $rootScope.pageConfiguration.header.solid) { solid(); }
					else { transparent(); }
					previousPageYOffset = $window.pageYOffset;
				});
			});

			angular.element($window).bind('scroll', updateHeaderScroll);
			angular.element($window).bind('resize', updateRatingHeader);
			$scope.$on('$destroy', function(event) {
				angular.element($window).unbind('resize', updateRatingHeader);
				angular.element($window).unbind('scroll', updateHeaderScroll);
			});

			$rootScope.$watch('pageConfiguration', function (newValue, oldValue) {
				angular.element(document).ready(function () {
					$timeout(function () {
						updateMainMargin();
						updateRatingHeader();
						angular.element("header-shargo .header-container-solid").css("background-image", $rootScope.pageConfiguration.header.background);
						if ($window.pageYOffset >= $rootScope.pageConfiguration.header.solid) { solid(); }
						else { transparent(); }
					});
				});
			});
		});
})();